import React, { useState } from "react";
import CommonFormLabel from "../../components/formLabel";
import { useNavigate, useLocation } from "react-router-dom";
import ValidationFeedback from "../../components/validationFeedback";
import CommonButton from "../../components/commonButton";
// import CommonEditor from "../../components/commonEditor";
import { useDispatch } from "react-redux";
import { Toast, Form, Row, Col, Card } from "react-bootstrap";
import { Formik } from "formik";
import { faqSchema } from "../../schema/validationSchemas";
import { addFaq } from "./faqSlice";
import Editor from "../../components/commonEditor";
import TextArea from "../../components/commonTextArea";

export default function Add() {
  const navigate = useNavigate();
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const currentPage = params.get("page") || 1;
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const selected_organization_id = pathSegments.length > 1 && pathSegments[0] === "organization" 
    ? pathSegments[1] 
    : null;

  const initialEventState = {
    organization_id: selected_organization_id,
    // parent_faq_id: "",
    question: "",
    answer: "",
    sequence: "", 
  };

  const handleModalClose = () => {
    navigate(`/organization/${selected_organization_id}/faqs?page=${currentPage}&order_by=sequence&order=asc`);
  };

  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    setIsSubmitting(true);

    const dataToSubmit = {
      ...values,
    };

    await dispatch(addFaq(dataToSubmit))
      .then((res) => {
        if (res.payload && res.payload.success) {
          localStorage.setItem("faq_notify_message", res.payload.message);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("success");
          setShowSnackbar(true);
          setSubmitting(false);
          setIsSubmitting(false);
          navigate(`/organization/${selected_organization_id}/faqs?page=${currentPage}&order_by=sequence&order=asc`);
        } else {
          // setSnackbarMessage("Failed to add faq!");
          setErrors(res.payload.data);
          setSnackbarMessage(res.payload.message || "Failed to add faq!");
          setSnackbarVariant("danger");
          setShowSnackbar(true);
          setSubmitting(false);
          setIsSubmitting(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setSnackbarMessage("Failed to add faq!");
        setSnackbarVariant("danger");
        setShowSnackbar(true);
        setSubmitting(false);
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <Toast
        onClose={() => setShowSnackbar(false)}
        show={showSnackbar}
        delay={3000}
        autohide
        bg={snackbarVariant}
        style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
      >
        <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
      </Toast>

      <Formik
        initialValues={initialEventState}
        validationSchema={faqSchema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          touched,
          handleChange,
          handleSubmit,
          values,
          setFieldValue,
        }) => (
          <Form
            onSubmit={handleSubmit}
            encType="multipart/form-data"
            className="bg-white p-4 rounded-2 shadow-sm"
          >
            {/* <h3 className="mb-4 text-center">Add New faq</h3> */}
            <Card className="bg-white p-4 rounded-2 shadow-sm mb-4">
            <h4 className="mb-4 d-flex justify-content-center">Basic</h4>
              <Row>
                <Col md={12} className="">
                  <CommonFormLabel
                    htmlFor="question"
                    title="Question"
                  />
                  <TextArea
                    id="question"
                    name="question"
                    placeholder="Enter Question"
                    value={values.question}
                    onChange={handleChange}
                    className={`shadow-none ${errors?.question && touched.question ? 'error' : 'correct'}`}
                    rows={4}
                  />
                  {touched.question && errors?.question && (
                    <ValidationFeedback title={errors?.question} />
                  )}
                </Col>

                  <div className="mb-4">
                      <CommonFormLabel
                          htmlFor="answer"
                          title="Answer"
                      />
                      <Editor
                          value={values.answer}
                          onChange={(content) =>
                            setFieldValue("answer", content)
                          }
                      />
                      {touched.answer && errors?.answer && (
                          <ValidationFeedback title={errors?.answer} />
                      )}
                  </div>

                  {/* <Col md={6} className="mb-4">
                      <CommonFormLabel htmlFor="sequence" title="Sequence" />
                            <Input
                                id="sequence"
                                name="sequence"
                                type="number"
                                min="1"
                                placeholder="Enter Sequence"
                                onChange={handleChange}
                                className={`shadow-none ${
                                errors?.sequence && touched.sequence ? "error" : "correct"
                                }`}
                            />
                            {touched.sequence && errors?.sequence && (
                                <ValidationFeedback title={errors?.sequence} />
                            )}
                    </Col> */}
                    </Row>
              </Card>

            <div className="d-flex align-items-center justify-content-end gap-3 common-popup-btn mt-5">
              <CommonButton
                title={isSubmitting ? "Adding..." : "Add"}
                type="submit"
                disabled={isSubmitting}
                className="btn-primary primary-shadow"
              />
              <CommonButton
                title="Cancel"
                onClick={handleModalClose}
                className="btn-muted"
              />
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}
